export const itunesLink =
  "https://itunes.apple.com/us/app/puma-fastpay/id1121056844?ls=1&mt=8"

export const googlePlayLink =
  "https://play.google.com/store/apps/details?id=com.pumafastpay.app1"
